import { json, error } from "@sveltejs/kit";
import { P as PaymentValidator } from "../../../../../chunks/PaymentValidator.js";
import { p as prisma } from "../../../../../chunks/prisma.js";
import { s as sendEmail } from "../../../../../chunks/mailService.js";
const POST = async ({ request, url }) => {
  console.log(request.headers);
  try {
    const payload = await request.json();
    const validatedPayload = PaymentValidator.validateCallback(payload);
    if (validatedPayload?.status === "settled") {
      return await processPayment(validatedPayload, url);
    }
    return json({ message: "Notification acknowledged" });
  } catch (e) {
    console.error("Payment webhook error:", e);
    if (e instanceof Error) {
      return json(
        { error: e.message },
        {
          status: e.message.includes("not found") ? 404 : 500
        }
      );
    }
    return error(e?.status || 500, e?.body?.message || "Internal server error");
  }
};
async function processPayment(payload, url) {
  return await prisma.$transaction(
    async (tx) => {
      const cart = await tx.cart.findUnique({
        where: {
          paymentReference: payload.client_invoice_ref,
          status: "PENDING_PAYMENT"
        },
        include: {
          CartItem: { include: { product: true } },
          user: true
        }
      });
      if (!cart?.CartItem?.length) {
        throw error(404, "Cart not found or empty");
      }
      const order = await createOrder(tx, cart, payload);
      await updateInventory(tx, cart.CartItem);
      sendEmail(cart.user.email, "Order Confirmation - Kenya Law", "order-confirmation", {
        username: cart.user.name || cart.user.email,
        order: {
          ...order,
          ProductOnOrder: order.ProductOnOrder.map((item) => ({
            ...item,
            product: cart.CartItem.find((cartItem) => cartItem.productId === item.productId)?.product
          }))
        },
        origin: url.origin
      }).catch((error2) => console.error("Failed to send customer confirmation email:", error2));
      sendEmail("thomas.kigarde@bsl.co.ke", "New Order Received - Kenya Law", "new-order-notification", {
        order: {
          ...order,
          ProductOnOrder: order.ProductOnOrder.map((item) => ({
            ...item,
            product: cart.CartItem.find((cartItem) => cartItem.productId === item.productId)?.product
          }))
        },
        origin: url.origin
      }).catch((error2) => console.error("Failed to send admin notification email:", error2));
      await tx.cart.delete({ where: { id: cart.id } });
      return json({ success: true, order });
    },
    {
      timeout: 1e4,
      isolationLevel: "Serializable"
    }
  );
}
async function createOrder(tx, cart, payload) {
  const totalPrice = cart.CartItem.reduce((sum, item) => sum + item.product.price * item.quantity, 0);
  return await tx.order.create({
    data: {
      userId: cart.userId,
      totalPrice,
      status: "COMPLETED",
      billRefNumber: payload.client_invoice_ref,
      invoiceNumber: payload.invoice_number,
      description: `Payment via ${payload.payment_channel}`,
      ProductOnOrder: {
        createMany: {
          data: cart.CartItem.map((item) => ({
            productId: item.productId,
            quantity: item.quantity
          }))
        }
      }
    },
    include: {
      ProductOnOrder: true
    }
  });
}
async function updateInventory(tx, cartItems) {
  await Promise.all(
    cartItems.map(
      (item) => tx.product.update({
        where: { id: item.productId },
        data: { quantity: { decrement: item.quantity } }
      })
    )
  );
}
export {
  POST
};
